import { ContactDto, ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { put, takeEvery } from 'redux-saga/effects';

import PlaceName from '../../../models/interfaces/PlaceName';
import { addPlace, InitializePlaceActionType, placeAdded, placeAdditionFailed } from '../../actions/place/addPlace';
import getAuthenticationToken from '../getAuthenticationToken';
import getProtectedResponse from '../getProtectedResponse';

function* initializePlaceSaga({ payload }: InitializePlaceActionType) {
  const { uuid, companyUuid, placeUuid, name, uniqueName, address } = payload;
  const { street, number, cityRo, cityEn, cityHu, country, geometry } = address;
  const { lat, lng } = geometry;
  const token = yield getAuthenticationToken();
  const contactDto: ContactDto = {
    uuid,
    placeUuid,
    name,
    uniqueName,
    street,
    number,
    cityRo,
    cityHu,
    cityEn,
    country,
    latitude: lat,
    longitude: lng,
  };
  const response = yield getProtectedResponse(ProtectedServerPlaceEvent.createPlace, token, {
    companyUuid,
    contact: contactDto,
  });
  const timestamp = moment();
  const placeName: PlaceName = { uuid: placeUuid, name, uniqueName };
  const responsePayload = { timestamp, placeName };
  if (!response.error) {
    const responseAction = placeAdded(responsePayload);
    yield put(responseAction);
  } else {
    const responseAction = placeAdditionFailed(responsePayload);
    yield put(responseAction);
  }
}

export default function* watchinitializePlaceSaga() {
  yield takeEvery(addPlace, initializePlaceSaga);
}
